export default __webpack_public_path__ + "static/media/Hair_4_M_C5.305e3d30.svg";